// USM Haller 顏色推薦邏輯 (最終修正版：修復沙發鍵名不匹配問題)

let currentLang = 'en';

// 1. USM Haller 標準顏色列表 (已移除 matte_silver，共 14 種顏色)
const USM_COLORS = {
    pure_white: { zh: '純白色 (Pure White)', en: 'Pure White', code: '#F6F6F6', image_file: 'usm_cabinet_pure_white.png' },         
    light_grey: { zh: '淺灰色 (Light Grey)', en: 'Light Grey', code: '#A0A0A0', image_file: 'usm_cabinet_light_grey.png' },     
    mid_grey: { zh: '中灰色 (Mid Grey)', en: 'Mid Grey', code: '#7B7B7B', image_file: 'usm_cabinet_mid_grey.png' },             
    anthracite: { zh: '炭灰色 (Anthracite)', en: 'Anthracite', code: '#373F45', image_file: 'usm_cabinet_anthracite.png' },     
    graphite_black: { zh: '石墨黑 (Graphite Black)', en: 'Graphite Black', code: '#343434', image_file: 'usm_cabinet_black.png' }, 
    beige: { zh: '米色 (USM Beige)', en: 'USM Beige', code: '#D8C3A4', image_file: 'usm_cabinet_beige.png' },                 
    usm_brown: { zh: '棕色 (USM Brown)', en: 'USM Brown', code: '#8B4513', image_file: 'usm_cabinet_brown.png' },             
    golden_yellow: { zh: '金黃色 (Golden Yellow)', en: 'Golden Yellow', code: '#D99A3A', image_file: 'usm_cabinet_yellow.png' },   
    pure_orange: { zh: '純橙色 (Pure Orange)', en: 'Pure Orange', code: '#FF7F00', image_file: 'usm_cabinet_orange.png' },       
    ruby_red: { zh: '寶石紅 (Ruby Red)', en: 'Ruby Red', code: '#A02534', image_file: 'usm_cabinet_red.png' },             
    usm_green: { zh: '綠色 (USM Green)', en: 'USM Green', code: '#006B4C', image_file: 'usm_cabinet_green.png' },             
    olive_green: { zh: '橄欖綠 (Olive Green)', en: 'Olive Green', code: '#878864', image_file: 'usm_cabinet_olive.png' },       
    steel_blue: { zh: '鋼藍色 (Steel Blue)', en: 'Steel Blue', code: '#577B8D', image_file: 'usm_cabinet_steel_blue.png' },     
    gentian_blue: { zh: '紳士藍 (Gentian Blue)', en: 'Gentian Blue', code: '#435889', image_file: 'usm_cabinet_gentian_blue.png' }      
};

// 2. 梳化圖片映射表 (現在是輸入值到文件名的映射)
const SOFA_IMAGES = {
    'light-grey': 'sofa_light_grey.png',
    'off-white': 'sofa_off_white.png',
    'deep-grey': 'sofa_deep_grey.png',
    'light-blue': 'sofa_light_blue.png'
};

// 3. 牆身地板顏色映射表 (用於分層預覽的 CSS 背景模擬)
const ROOM_COLORS = {
    'pure-white': '#FFFFFF',
    'off-white-cream': '#F5F5DC',
    'light-grey-pastel': '#C0C0C0',
    'statement-dark': '#333333',
    'light-wood': '#F7F1E6',
    'mid-wood': '#D2B48C',
    'white': '#FFFFFF',
    'grey': '#CCCCCC',
};

// 4. 牆身地板背景圖片映射表 (只包含鍵名，等待 Liquid 注入)
const BACKGROUND_MAP = {
    'pure-white_light-wood': 'bg_pw_lw.jpg',
    'pure-white_mid-wood': 'bg_pw_mw.jpg',
    'pure-white_white': 'bg_pw_w.jpg',
    'pure-white_grey': 'bg_pw_g.jpg',
    
    'off-white-cream_light-wood': 'bg_owc_lw.jpg',
    'off-white-cream_mid-wood': 'bg_owc_mw.jpg',
    'off-white-cream_white': 'bg_owc_w.jpg',
    'off-white-cream_grey': 'bg_owc_g.jpg',
    
    'light-grey-pastel_light-wood': 'bg_lgp_lw.jpg',
    'light-grey-pastel_mid-wood': 'bg_lgp_mw.jpg',
    'light-grey-pastel_white': 'bg_lgp_w.jpg',
    'light-grey-pastel_grey': 'bg_lgp_g.jpg',

    'statement-dark_light-wood': 'bg_sd_lw.jpg',
    'statement-dark_mid-wood': 'bg_sd_mw.jpg',
    'statement-dark_white': 'bg_sd_w.jpg',
    'statement-dark_grey': 'bg_sd_g.jpg',
};

// 5. 雙語推薦文案 (L10n)
const L10n = {
    // 排名標籤 - 已加入圖標
    rank_1: { zh: '<span class="rank-icon">🥇</span> 隱形冠軍：純粹和諧', en: '<span class="rank-icon">🥇</span> Invisible Champion: Pure Harmony' },
    rank_2_warm: { zh: '<span class="rank-icon">🥈</span> 溫暖中性：奶油色調', en: '<span class="rank-icon">🥈</span> Warm Neutral: Creamy Tones' },
    rank_2_cool: { zh: '<span class="rank-icon">🥈</span> 質感層次：淺灰色', en: '<span class="rank-icon">🥈</span> Textured Layer: Light Grey' },
    rank_3_neutral: { zh: '<span class="rank-icon">🥉</span> 質感層次：淺灰色', en: '<span class="rank-icon">🥉</span> Textured Layer: Light Grey' },
    rank_3_contrast: { zh: '<span class="rank-icon">🥉</span> 極簡線條：石墨黑', en: '<span class="rank-icon">🥉</span> Minimalist Line: Graphite Black' },
    rank_3_metal: { zh: '✨ 現代經典：淺灰色', en: '✨ Modern Classic: Light Grey' },
    rank_1_focus: { zh: '🥇 派對之王：金黃色', en: '🥇 Party King: Golden Yellow' },
    rank_2_focus_blue: { zh: '🥈 知性對比：紳士藍', en: '🥈 Intellectual Contrast: Gentian Blue' },
    rank_3_drama: { zh: '🥉 戲劇效果：寶石紅', en: '🥉 Dramatic Effect: Ruby Red' },
    rank_3_nature: { zh: '🥉 活力自然：USM 綠', en: '🥉 Natural Vitality: USM Green' },
    rank_1_cool: { zh: '🥇 海洋平靜：鋼藍色', en: '🥇 Ocean Calm: Steel Blue' },
    rank_2_cool_green: { zh: '🥈 冷靜自然：橄欖綠', en: '🥈 Cool Nature: Olive Green' },
    rank_3_cool_grey: { zh: '🥉 現代冷調：炭灰色', en: '🥉 Modern Cool: Anthracite' },
    rank_1_warm: { zh: '🥇 奶油溫柔：USM 米色', en: '🥇 Creamy Softness: USM Beige' },
    rank_2_earth: { zh: '🥈 大地沉穩：USM 棕色', en: '🥈 Earthy Stability: USM Brown' },
    rank_3_sun: { zh: '🥉 活力陽光：純橙色', en: '🥉 Sunny Vibe: Pure Orange' },

    // 原因描述 (教育原理)
    reason_white: { zh: '與淺色背景融合得天衣無縫，極致通透。永遠是北歐風和諧感的首選。', en: 'Blends seamlessly with light backgrounds for maximum spaciousness. The timeless, safe Nordic choice.' },
    reason_light_grey: { zh: '保持低調和諧，但透過輕微的深淺變化增加空間質感，呈現高級灰調。', en: 'Maintains subtle harmony while adding sophistication and depth through layered light grey tones.' },
    reason_beige: { zh: '注入奶油色的溫暖感，將客廳打造成一個溫馨舒適的窩，提升溫馨度。', en: 'Infuses creamy warmth, transforming the living room into a cozy, comfortable haven.' },
    reason_black: { zh: '利用深色勾勒出俐落的現代線條，在淺色空間中創造極簡的視覺邊界。', en: 'Creates sharp, modern lines against light walls, establishing a minimalist visual boundary.' },
    reason_silver: { zh: '半透明的金屬質感，在光線下呈現柔和變化，適合追求高科技現代感的簡約風格。', en: 'Semi-transparent metallic texture, ideal for a subtle, high-tech modern aesthetic.' },
    reason_yellow: { zh: '明快而充滿陽光的顏色，瞬間點亮空間！讓電視櫃成為客廳最搶眼的藝術品。', en: 'Bright and sunny, this colour instantly uplifts the space! Turns the TV cabinet into eye-catching art.' },
    reason_gentian_blue: { zh: '深邃而知性的藍色，為淺色背景提供了一個沉穩的錨點，既吸睛又不失格調。', en: 'A deep, intellectual blue that anchors the light background, providing contrast without sacrificing elegance.' },
    reason_ruby_red: { zh: '強烈的寶石紅在極簡背景下帶來巨大的視覺衝擊。挑戰您的客廳個性極限！', en: 'Intense ruby red delivers a strong visual punch against a minimalist backdrop. Maximize your room\'s personality!' },
    reason_usm_green: { zh: '標誌性的 USM 綠色，充滿復古和自然氣息，與淺木地板搭配效果絕佳。', en: 'The iconic USM green, full of retro and natural charm, pairs excellently with light wood floors.' },
    reason_steel_blue: { zh: '飽和度適中的深藍色，營造寧靜清爽的氛圍。是北歐風最受歡迎的冷色調之一。', en: 'A well-balanced deep blue, creating a calm, refreshing atmosphere. A Nordic favorite.' },
    reason_olive_green: { zh: '帶有灰度的綠色，相比純藍色更貼近自然，保持了清爽的氛圍，同時更具設計感。', en: 'A desaturated green, closer to nature, maintaining a fresh atmosphere while adding a sophisticated design touch.' },
    reason_anthracite: { zh: '比黑白更具現代感的冷灰色調。它提供了一個穩固的基礎，讓空間感覺更冷靜、俐落。', en: 'A cooler, more contemporary alternative to black/white. Provides a stable base for a calm, sleek look.' },
    reason_usm_brown: { zh: '深沉的棕色與淺木色形成溫暖對比，帶來圖書館或窩居的沉穩感，適合追求經典溫暖的風格。', en: 'Deep brown contrasts warmly with light wood, creating a stable, library-like coziness for classic warmth.' },
    reason_orange: { zh: '為客廳帶來一抹熱情，與暖色木質地板協調一致，使空間更具活力和親切感。', en: 'Adds a touch of warmth and enthusiasm, harmonizing with wood floors for a dynamic, friendly space.' },

    // 校正原因
    corr_white: { zh: '【亮度校正】空間採光不足，選擇純白能最大化反光，提升整體亮度。', en: '【Brightness Correct】Low light requires Pure White to maximize reflection and brighten the room.' },
    corr_steel_blue: { zh: '【溫度校正】暖光環境中，鋼藍色能提供視覺冷卻，平衡空間溫度。', en: '【Temp Correct】Warm lighting benefits from Steel Blue for visual cooling and temperature balance.' },
    corr_light_grey: { zh: '【視覺層次】牆身已為焦點，櫃體應選擇淺灰來保持視覺喘息空間和極簡平衡。', en: '【Visual Layering】The wall is the focus; Light Grey maintains visual breathing room and minimal balance.' },
    
    // 教育原理
    edu_harmony: { zh: '【色彩原理：同色系與亮度搭配】選擇與背景色相近的顏色，創造連續性。這是北歐設計中維持開放感和極簡主義的關鍵。', en: '【Color Theory: Tonal Harmony】Choosing colours close to the background creates visual continuity. This is key in Nordic design to maintain an open, minimalist feel.' },
    edu_focus: { zh: '【色彩原理：互補與三色搭配】利用色輪上對比鮮明的顏色（如藍/黃或紅/綠）創造強烈的視覺衝擊，使焦點區域瞬間突出。', en: '【Color Theory: Complementary Contrast】Use contrasting colours (like Blue/Yellow or Red/Green) on the color wheel to create visual punch and instantly highlight the focal area.' },
    edu_warm: { zh: '【色彩原理：暖色光譜】暖色系（紅、橙、黃）能夠在視覺上「前進」，使空間更親密、溫馨。適合自然採光不足的環境。', en: '【Color Theory: Warm Spectrum】Warm colours (red, orange, yellow) visually "advance," making the space feel more intimate and cozy. Ideal for spaces lacking natural light.' },
    edu_cool: { zh: '【色彩原理：冷色收縮】冷色系（藍、綠、紫）能夠在視覺上「後退」，使空間感覺更寬敞、寧靜。適合用於緩解夏日熱感。', en: '【Color Theory: Cool Spectrum】Cool colours (blue, green, purple) visually "recede," making the space feel larger and more serene. Excellent for visual cooling.' }
};


// 語言切換函數
function setLanguage(lang) {
    currentLang = lang;
    
    document.querySelectorAll('[data-lang-zh], [data-lang-en]').forEach(el => {
        const key = `data-lang-${lang}`;
        if (el.hasAttribute(key)) {
            el.textContent = el.getAttribute(key);
        }
    });
    document.querySelectorAll('select option').forEach(option => {
        const zhText = option.getAttribute('data-lang-zh');
        const enText = option.getAttribute('data-lang-en');
        if (zhText && enText) {
             option.textContent = lang === 'zh' ? zhText : enText;
        }
    });

    document.getElementById('lang-zh').classList.remove('active');
    document.getElementById('lang-en').classList.remove('active');
    document.getElementById(`lang-${lang}`).classList.add('active');

    if (!document.getElementById('result-section').classList.contains('hidden')) {
        generateRecommendation();
    }
}

document.addEventListener('DOMContentLoaded', () => {
    // --- 核心 Liquid 注入數據處理 ---
    
    // 注入 USM 櫃體圖片 URL
    for (const key in USM_COLORS) {
        const fileName = USM_COLORS[key].image_file;
        // 檢查 Liquid 注入的全局變量是否存在並包含該文件名
        if (window.USM_CABINET_URLS && window.USM_CABINET_URLS[fileName]) {
            USM_COLORS[key].image_file = window.USM_CABINET_URLS[fileName];
        }
    }
    
    // 注入梳化圖片 URL (使用文件名作為鍵進行查找)
    const tempSofaImages = {};
    for (const key in SOFA_IMAGES) {
        const fileName = SOFA_IMAGES[key];
        if (window.SOFA_URLS && window.SOFA_URLS[fileName]) {
            // 將 SOFA_IMAGES 結構更改為: {'light-grey': 'CDN_URL'}
            tempSofaImages[key] = window.SOFA_URLS[fileName];
        } else {
            tempSofaImages[key] = fileName; // 保持文件名作為備用
        }
    }
    // 覆蓋舊的 SOFA_IMAGES，使其現在包含 CDN URL
    Object.assign(SOFA_IMAGES, tempSofaImages); 

    // --- 結束 Liquid 注入處理 ---

    setLanguage('en'); 
});


// 獲取首選顏色，並暫存，用於單擊切換預覽時恢復
let topColor = null; 

// 核心預覽切換函數：設置 USM 櫃體的圖片
function setPreviewCabinet(colorObject) {
    const previewUsmlayer = document.getElementById('preview-usm-layer');
    
    if (!colorObject || !colorObject.image_file) {
        previewUsmlayer.style.opacity = 0;
        return;
    }
    
    // colorObject.image_file 現在是完整的 CDN URL
    previewUsmlayer.src = colorObject.image_file;
    previewUsmlayer.alt = colorObject[currentLang] + ' USM Haller Preview';
    
    previewUsmlayer.style.opacity = 1;
}

function generateRecommendation() {
    const sofaColor = document.getElementById('sofa-color').value;
    const floorColor = document.getElementById('floor-color').value;
    const wallColor = document.getElementById('wall-color').value;
    const lighting = document.getElementById('lighting').value;
    const targetStyle = document.getElementById('target-style').value;
    const outputDiv = document.getElementById('recommendation-output');
    const masterclassOutput = document.getElementById('masterclass-output');
    
    // 獲取預覽元素
    const previewSofaLayer = document.getElementById('preview-sofa-layer');
    const previewBackground = document.getElementById('preview-background');
    const previewPlaceholder = document.getElementById('preview-placeholder');

    // --- 推薦邏輯 ---
    let recommendations = [];
    let initialRecs = [];
    let eduReason = {};
    
    // 基礎推薦
    if (targetStyle === 'harmony') {
        initialRecs = [
            { rank: L10n.rank_1, color: USM_COLORS.pure_white, reason: L10n.reason_white },
            { rank: L10n.rank_2_warm, color: USM_COLORS.beige, reason: L10n.reason_beige },
            { rank: L10n.rank_3_neutral, color: USM_COLORS.light_grey, reason: L10n.reason_light_grey }
        ];
        eduReason = L10n.edu_harmony;
        if (sofaColor === 'deep-grey') initialRecs.splice(1, 0, { rank: L10n.rank_3_contrast, color: USM_COLORS.graphite_black, reason: L10n.reason_black });
    } else if (targetStyle === 'focus') {
        initialRecs = [
            { rank: L10n.rank_1_focus, color: USM_COLORS.golden_yellow, reason: L10n.reason_yellow },
            { rank: L10n.rank_2_focus_blue, color: USM_COLORS.gentian_blue, reason: L10n.reason_gentian_blue },
            { rank: L10n.rank_3_nature, color: USM_COLORS.usm_green, reason: L10n.reason_usm_green }
        ];
        eduReason = L10n.edu_focus;
        if (floorColor === 'white' || floorColor === 'grey') initialRecs[2] = { rank: L10n.rank_3_drama, color: USM_COLORS.ruby_red, reason: L10n.reason_ruby_red };
    } else if (targetStyle === 'cool') {
        initialRecs = [
            { rank: L10n.rank_1_cool, color: USM_COLORS.steel_blue, reason: L10n.reason_steel_blue },
            { rank: L10n.rank_2_cool_green, color: USM_COLORS.olive_green, reason: L10n.reason_olive_green },
            { rank: L10n.rank_3_cool_grey, color: USM_COLORS.anthracite, reason: L10n.reason_anthracite }
        ];
        eduReason = L10n.edu_cool;
    } else if (targetStyle === 'warm') {
        initialRecs = [
            { rank: L10n.rank_1_warm, color: USM_COLORS.beige, reason: L10n.reason_beige },
            { rank: L10n.rank_2_earth, color: USM_COLORS.usm_brown, reason: L10n.reason_usm_brown },
            { rank: L10n.rank_3_sun, color: USM_COLORS.pure_orange, reason: L10n.reason_orange }
        ];
        eduReason = L10n.edu_warm;
    }
    
    // 應用校正邏輯
    recommendations = initialRecs;
    if (lighting === 'dim-shadow' && initialRecs[0].color !== USM_COLORS.pure_white) {
        recommendations.unshift({ rank: { zh: '💡 亮度校正', en: '💡 Brightness Correct' }, color: USM_COLORS.pure_white, reason: L10n.corr_white });
        recommendations.splice(3); 
    }
    if (lighting === 'warm-bulb' && recommendations.some(rec => rec.color === USM_COLORS.beige || rec.color === USM_COLORS.usm_brown)) {
        const steelBlueRec = { rank: { zh: '🌡️ 溫度校正', en: '🌡️ Temp Correct' }, color: USM_COLORS.steel_blue, reason: L10n.corr_steel_blue };
        if (!recommendations.some(rec => rec.color === USM_COLORS.steel_blue)) { recommendations.splice(1, 1, steelBlueRec); }
        recommendations.splice(3); 
    }
    if (wallColor === 'statement-dark' && targetStyle !== 'focus' && recommendations[0].color !== USM_COLORS.light_grey) {
        recommendations.unshift({ rank: { zh: '🧱 牆色優先', en: '🧱 Wall Priority' }, color: USM_COLORS.light_grey, reason: L10n.corr_light_grey });
        recommendations.splice(3); 
    }
    recommendations.splice(3); 

    if (recommendations.length === 0) {
        previewPlaceholder.style.display = 'flex';
        previewSofaLayer.style.opacity = 0;
        setPreviewCabinet(null);
        document.getElementById('result-section').classList.add('hidden');
        return;
    }

    // 將首選顏色暫存到全局變量
    topColor = recommendations[0].color;
    
    // 1. 顯示圖層
    previewPlaceholder.style.display = 'none';
    previewSofaLayer.style.opacity = 1;

    // 2. 設置背景層（牆身和地板圖片）
    const bgKey = `${wallColor}_${floorColor}`;
    const bgFileUrl = window.BACKGROUND_URLS[bgKey] || 'default_bg.jpg'; 
    previewBackground.src = bgFileUrl; // 使用 Liquid 注入的 CDN URL
    previewBackground.style.opacity = 1; 

    // 3. 設置梳化層 - FIX: 直接使用 SOFA_IMAGES[sofaColor] (現在它包含 CDN URL)
    previewSofaLayer.src = SOFA_IMAGES[sofaColor]; 

    // 4. 設置 USM 櫃體層 (顯示首選顏色)
    setPreviewCabinet(topColor);


    // --- 渲染結果 (整合教育原理) ---
    outputDiv.innerHTML = ''; 
    masterclassOutput.innerHTML = ''; 

    // 1. 渲染教育原理總結 (使用 Masterclass 樣式)
    masterclassOutput.innerHTML = `
        <div class="masterclass-box">
            <div class="recommendation-rank">${currentLang === 'zh' ? '⭐ 設計大師課' : '⭐ Design Masterclass'}</div>
            <div class="color-reason">
                ${currentLang === 'zh' ? eduReason.zh : eduReason.en}
            </div>
        </div>
    `;

    // 2. 渲染顏色推薦
    recommendations.forEach(rec => {
        const item = document.createElement('div');
        item.classList.add('recommendation-item');
        
        const rankText = currentLang === 'zh' ? rec.rank.zh : rec.rank.en;
        const colorName = currentLang === 'zh' ? rec.color.zh : rec.color.en;
        const reasonText = currentLang === 'zh' ? rec.reason.zh : rec.reason.en; 
        
        // 單擊事件：實時更新預覽 (移動端友好)
        item.onclick = () => setPreviewCabinet(rec.color);

        // 渲染內容：圓形色塊和徽章
        item.innerHTML = `
            <div class="recommendation-rank">${rankText}</div>
            <div class="color-block" style="background-color: ${rec.color.code};" title="${rec.color[currentLang]}"></div>
            <div class="color-name">${colorName}</div>
            <div class="color-reason">${reasonText}</div>
        `;
        outputDiv.appendChild(item);
    });
}